/**
 * Runtime environment detection.
 *
 * Both app surfaces are deployed separately for UAT and production. Runtime
 * hostname detection is only used for environment labels and local affordances;
 * deployment-specific URLs come from the GitHub environment used at build time.
 */

export type DeploymentEnvironment = "live" | "test" | "local";

/** Hostnames that are considered production for either surface. */
const LIVE_HOSTNAMES = [
  "my-quotes.insurancerevolution.cloud",
  "admin-marketplace.insurancerevolution.cloud",
];

const LOCAL_HOSTNAMES = ["localhost", "127.0.0.1", "0.0.0.0", "::1"];

export function getHostname(): string {
  if (typeof window === "undefined") return "";
  return window.location.hostname;
}

export function getEnvironment(): DeploymentEnvironment {
  const hostname = getHostname();
  if (!hostname) return "live";
  if (LOCAL_HOSTNAMES.includes(hostname)) return "local";
  if (LIVE_HOSTNAMES.some((live) => hostname.includes(live))) return "live";
  return "test";
}

export function isLocalEnvironment(): boolean {
  return getEnvironment() === "local";
}
